export type AulaBootstrapSession = {
  access_token: string
  refresh_token: string
}

export function safeLocalRedirect(raw: string | null | undefined, fallback: string): string {
  if (typeof raw !== 'string' || !raw.trim()) return fallback
  let candidate: string
  try {
    candidate = decodeURIComponent(raw.trim())
  } catch {
    return fallback
  }
  if (!candidate.startsWith('/') || candidate.startsWith('//') ||
      candidate.includes('\\') || /[\u0000-\u001f\u007f]/.test(candidate)) return fallback
  try {
    const url = new URL(candidate, 'https://theaula.com')
    return url.origin === 'https://theaula.com' ? candidate : fallback
  } catch {
    return fallback
  }
}

/** An authenticated session is not a ready Aula teacher account until setup succeeds. */
export async function syncAulaAccount(session: AulaBootstrapSession | null | undefined, registrationCode?: string): Promise<{ role?: string; created_personal_org?: boolean; auth_created_at?: string }> {
  if (!session?.access_token || !session.refresh_token) {
    throw new Error('session_missing')
  }

  const controller = new AbortController()
  const timeout = setTimeout(() => controller.abort(), 30_000)
  let response: Response
  try {
    response = await fetch('/api/auth/sync', {
    signal: controller.signal,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    cache: 'no-store',
    body: JSON.stringify({
      access_token: session.access_token,
      refresh_token: session.refresh_token,
      registration_code: registrationCode?.trim().toUpperCase() || null,
    }),
    })
  } finally {
    clearTimeout(timeout)
  }
  const result = await response.json().catch(() => null)
  if (!response.ok || !result?.ok) {
    throw new Error('account_setup_failed')
  }
  return result
}
